import React from "react";
import { Quotes, Star } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../landing/home/HomeTestimonials";
import { FOR_TESTIMONIALS, fill } from "../../data/forPageContent";
import useStartReveal from "../start/useStartReveal";
import "../start/StartSections.css";

/** Split "רונית כ., קלינאית תקשורת" → { author, role }. */
const splitAuthor = (s = "") => {
  const idx = s.indexOf(", ");
  return idx === -1 ? { author: s, role: "" } : { author: s.slice(0, idx), role: s.slice(idx + 2) };
};

/**
 * Page quote first, then up to two real quotes from HomeTestimonials
 * (same card anatomy as StartTestimonials).
 */
export default function ForTestimonials({ pageData }) {
  const ref = useStartReveal();
  const own = pageData?.testimonialQuote
    ? [{ quote: pageData.testimonialQuote, rating: 5, ...splitAuthor(pageData.testimonialAuthor) }]
    : [];
  const items = [...own, ...TESTIMONIALS.filter((t) => t.quote !== own[0]?.quote).slice(0, 2)];
  if (items.length === 0) return <section id="start-testimonials" className="st-anchor" aria-hidden="true" />;

  return (
    <section id="start-testimonials" className="st-section st-tes" aria-labelledby="st-tes-title">
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{FOR_TESTIMONIALS.overline}</p>
        <h2 id="st-tes-title" className="st-h2 st-center">{fill(FOR_TESTIMONIALS.title, pageData)}</h2>
        <div className={`st-tes-grid${items.length === 1 ? " st-tes-grid--single" : ""}`}>
          {items.map((t) => (
            <figure key={t.quote} className="st-tes-card">
              <Quotes size={28} weight="fill" className="st-tes-quote-icon" aria-hidden="true" />
              <blockquote className="st-tes-quote">{t.quote}</blockquote>
              <figcaption className="st-tes-meta">
                <span className="st-tes-author">{t.author}</span>
                {t.role && <span className="st-tes-role">{t.role}</span>}
                {t.rating > 0 && (
                  <span className="st-tes-stars" role="img" aria-label={`${t.rating} מתוך 5 כוכבים`}>
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <Star key={i} size={14} weight="fill" />
                    ))}
                  </span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
